export * from "./permission-widget.component";
export * from "./permission-widget-event.struct";
